import { inject, Injectable, signal } from '@angular/core';
import { DokumentAfsendelseDatasource } from '@features/dokumenter/afsendelse/dokument-afsendelse.datasource';
import { DokumentAfsendelseSearchParams } from './dokument-afsendelse-search/dokument-afsendelse-search-params.model';
import { DokumentAfsendelse } from './dokument-afsendelse.model';

@Injectable({
  providedIn: 'root',
})
export class DokumentAfsendelseService {
  datasource = inject(DokumentAfsendelseDatasource);

  activeTab = signal('search');

  selectedDokumenter = signal<DokumentAfsendelse[]>([]);

  async searchDokument(searchParams: DokumentAfsendelseSearchParams) {
    this.datasource.searchParams.set(searchParams);
    await this.datasource.loadData();
    const data = this.datasource.data();
    if (data && data.totalRowCount > 0) {
      this.activeTab.set('result');
    }
  }
}
